import React from 'react';
import { Mail, Shield } from 'lucide-react';

const Contact = () => {
  return (
    <section 
      id="contact" 
      className="py-16 px-6 bg-section-light"
      data-testid="contact-section"
    >
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-[2rem] md:text-[2.5rem] font-bold text-[#1a1a1a] mb-2 tracking-tight">
            Get in Touch
          </h2>
          <p className="text-[#5a5a5a]">
            Considering your options? We'd be pleased to have an initial conversation.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          <div className="md:col-span-2 section-card-elevated overflow-hidden">
            <iframe
              src="https://docs.google.com/forms/d/e/1FAIpQLSek-3SlsCiGC08a7Xz2gsMZKZs9Wuf-T4srncjhnUasG6WkFg/viewform?embedded=true"
              width="100%"
              height="600"
              frameBorder="0"
              marginHeight="0"
              marginWidth="0"
              title="Contact Form"
              className="w-full bg-white"
              data-testid="contact-form-iframe"
            >
              Loading...
            </iframe>
          </div>

          <div className="space-y-4">
            <div className="section-card p-5">
              <div className="flex items-center gap-2 mb-2">
                <Mail className="w-4 h-4 text-[#1e3a5f]" />
                <span className="text-xs font-semibold text-[#5a5a5a]">Email directly</span>
              </div>
              <a 
                href="mailto:hello@crestfieldservices.co.uk"
                className="text-[#1e3a5f] font-semibold text-sm hover:underline block"
              >
                hello@crestfieldservices.co.uk
              </a>
            </div>

            <div className="bg-[#1e3a5f]/8 rounded-xl p-5 border border-[#1e3a5f]/15">
              <div className="flex items-start gap-2">
                <Shield className="w-4 h-4 text-[#1e3a5f] mt-0.5 flex-shrink-0" />
                <div>
                  <p className="font-semibold text-[#1a1a1a] text-xs mb-1">Strict Confidentiality</p>
                  <p className="text-[#5a5a5a] text-xs">
                    NDA available before sharing sensitive information.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
